import { createFileRoute, Link } from '@tanstack/react-router'
import { Prose } from '@/components/Prose'

export const Route = createFileRoute('/_layout/about')({
  component: AboutPage,
})

function AboutPage() {
  return (
    <section className="mx-auto max-w-3xl px-4 py-16">
      <Prose>
        <h1 className="text-text-primary">About Lunara</h1>
        <p>
          Lunara is an independent period and cycle tracker that runs entirely in your web browser.
          It helps you log your period, understand your symptoms, and see what&apos;s coming in your
          cycle — and it respects that cycle data is deeply personal.
        </p>

        <h2 className="text-text-primary">Your data, your choice</h2>
        <p>
          By default, Lunara stores your data only on your device using your browser&apos;s
          IndexedDB. It is not uploaded to any server. You can use the full tracker — logging
          periods, symptoms and predictions — with no account and no network connection. If you
          choose to create an account, your data is encrypted on your device before it ever leaves,
          and our server only ever stores ciphertext it cannot decrypt — so you can sync and back up
          across your devices without trusting us with the contents.
        </p>

        <h2 className="text-text-primary">What Lunara is (and is not)</h2>
        <p>
          Lunara is an awareness and journaling tool. It estimates your next period, fertile window
          and ovulation day from your own cycle history using the calendar method. These estimates
          are approximate. Lunara is <strong>not</strong> a medical device, is <strong>not</strong>{' '}
          a contraceptive, and is <strong>not</strong> a substitute for advice from a qualified
          healthcare provider.
        </p>

        <h2 className="text-text-primary">Independent and ad-light</h2>
        <p>
          Lunara is a small, independent project. We keep advertising to public content pages only
          and never run ads or analytics inside the tracker itself. If you find Lunara useful, the
          best way to support it is to tell someone who might benefit.
        </p>

        <p>
          <Link to="/contact" className="font-medium">
            Get in touch →
          </Link>
        </p>
      </Prose>
    </section>
  )
}
